module.exports = __webpack_public_path__ + "img/Requests.f464e008.svg";